import React from 'react';
import Switch from "react-switch";
import { CIRCLE_DIAMETER, primaryColor, secondaryColor, SWITCH_HEIGHT } from "../constants/colorsAndSIzes";

const OnSymbol = ({onText}) => {
  return (
    <div className="switch-on">
      {onText}
    </div>
  );
};

const OffSymbol = ({offText}) => {
  return (
    <div className="switch-off">
      {offText}
    </div>
  );
}

export default function ReactSwitch({
  state,
  updateState,
  onText = "On",
  offText = "",
  switchWidth
}) {
  return (
    <Switch
      uncheckedIcon={<OffSymbol offText={offText} />}
      checkedIcon={<OnSymbol onText={onText} />}
      onColor={primaryColor}
      offColor={secondaryColor}
      height={SWITCH_HEIGHT}
      width={switchWidth}
      handleDiameter={CIRCLE_DIAMETER}
      onChange={updateState}
      checked={state}
    />
  )
}